import React from "react";
import { Link, } from "react-router-dom";

// --------------------------------------------------

// const Link = () => null;

export default () => (
	<div>
		<h2>Something went wrong logging in...</h2>
		<Link to = "/login">Click here to try again</Link>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/AuthError.js